import React from 'react';

const contactData = [
  {
    iconClass: 'fas fa-phone-alt',  // phone icon for contact number
    title: 'Contact',
    content: (
      <ul className="contact-box_list">
        <li>Mobile: <a href="tel:7507048333">7507048333</a></li>
      </ul>
    ),
  },
  {
    iconClass: 'fas fa-envelope',  // email icon for email
    title: 'Email',
    content: (
      <ul className="contact-box_list">
        <li>booking@platinum24cab.com</li>
      </ul>
    ),
  },
  {
    iconClass: 'fas fa-map-marked-alt',  // address icon for address
    title: 'Address',
    content: (
      <p className="contact-box__text">
        OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
      </p>
    ),
  },
];

const ContactBoxSection = () => {
  return (
    <>
      <div
        className="breadcumb-wrapper"
        // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
      >
        <div className="container z-index-common">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Contact Us</h1>
            <div className="breadcumb-menu-wrap"></div>
          </div>
        </div>
      </div>

      <section className="space contact-box_wrapper">
        <div className="outer-wrap">
          <div className="container">
            <div className="row">
              {contactData.map((item, index) => (
                <div className="col-lg-4 col-md-6" key={index}>
                  <div className="contact-box">
                    <div className="contact-box_icon">
                      <i className={item.iconClass}></i>
                    </div>
                    <h3 className="contact-box__title h5">{item.title}</h3>
                    {item.content}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d186.74118639497098!2d73.84959074263809!3d18.648043339180404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c7f3bae12abb%3A0x70a5b506b09ceb81!2sAccord%20Hospitals!5e1!3m2!1sen!2sin!4v1758802420974!5m2!1sen!2sin" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>


    </>
  );
};

export default ContactBoxSection;
